import _ from 'lodash'
import { Icon } from '../icon'
import { getPagers } from './utils'

export default {
  name: 'KPager',
  inject: ['context'],
  data() {
    return {
    }
  },
  computed: {
    totalPage() {
      return this.context.totalPage
    },
    pagerCount() {
      return this.context.pagerCount
    },
    current: {
      get() {
        return this.context.current
      },
      set(value) {
        this.context.current = value
      },
    },
    offset() {
      return (this.pagerCount - 1) / 2 - 1
    },
    pagers() {
      const { current, offset, totalPage, pagerCount } = this
      return getPagers(current, offset, totalPage, pagerCount)
    },
    disabled() {
      return this.context.disabled
    },
  },
  watch: {},
  methods: {
    handleClick(value) {
      if (value < 1) {
        value = 1
      } else if (value > this.totalPage) {
        value = this.totalPage
      }
      this.current = value
    },
    getData({ value } = {}) {
      const style = {}

      const css = {
        'km-pagination__pager': true,
      }

      const attrs = {
        disabled: this.disabled,
      }

      const props = {}

      const events = {
        click: () => {
          this.handleClick(value)
        },
      }

      const data = {
        style: style,
        class: css,
        attrs: attrs,
        props: props,
        on: events,
      }

      return data
    },
    renderPager(pager) {
      const renderMethod = _.camelCase(`render ${pager.type}`)
      return this[renderMethod](pager)
    },
    renderArrow({ prev, value }) {
      const data = this.getData({ value })

      const iconName = prev ? 'angle-left' : 'angle-right'
      const disabled = this.disabled || (prev ? this.current <= 1 : this.current >= this.totalPage)

      _.assign(data.attrs, {
        disabled,
      })

      return (
        <a {...data} class="km-pagination__pager--arrow">
          <Icon name={iconName}></Icon>
        </a>
      )
    },
    renderNumber({ value }) {
      const data = this.getData({ value })

      _.assign(data.class, {
        'km-pagination__pager--current': value === this.current,
      })

      return (
        <a {...data}>
          {value}
        </a>
      )
    },
    renderEllipsis({ prev, value }) {
      const arrowIcon = prev ? 'angle-double-left' : 'angle-double-right'

      return (
        <a {...this.getData({ value })}>
          <Icon class="km-pagination__pager__default-icon" name="ellipsis-h"></Icon>
          <Icon class="km-pagination__pager__hovered-icon" name={arrowIcon}></Icon>
        </a>
      )
    },
  },
  render() {
    return (
      <div class="km-pagination__pagers">
        {
          _.map(this.pagers, pager => this.renderPager(pager))
        }
      </div>
    )
  },
}
